import {
  HARDENING_CLUSTERS as HARDENING_CLUSTERS_CONST,
  HARDENING_POLICY_STATUS as HARDENING_POLICY_STATUS_CONST,
} from '@/lib/constants/hardening'

export const HARDENING_CLUSTERS = {
  [HARDENING_CLUSTERS_CONST.AUDIT]: 'Auditoría',
  [HARDENING_CLUSTERS_CONST.REMOTE_ACCESS]: 'Acceso Remoto',
  [HARDENING_CLUSTERS_CONST.PASSWORD_SECURITY]: 'Política de Contraseñas',
  [HARDENING_CLUSTERS_CONST.DISK_ENCRYPTION]: 'Cifrado de Disco',
  [HARDENING_CLUSTERS_CONST.SCREEN_LOCK]: 'Bloqueo de Pantalla',
  [HARDENING_CLUSTERS_CONST.PRIVILEGE_PROTECTION]: 'Protección de Privilegios',
  [HARDENING_CLUSTERS_CONST.HOST_FIREWALL]: 'Firewall',
}

export const HARDENING_POLICY_STATUS = {
  [HARDENING_POLICY_STATUS_CONST.PASSED]: 'Aprobado',
  [HARDENING_POLICY_STATUS_CONST.WARNING]: 'Advertencia',
  [HARDENING_POLICY_STATUS_CONST.FAILED]: 'Rechazado',
  [HARDENING_POLICY_STATUS_CONST.NOT_APPLICABLE]: 'No Aplicable',
}

export const HARDENING_ASSET_TYPES = {
  SERVER: 'Servidor',
  LAPTOP: 'Laptop',
}

export const HARDENING_ASSET_TABLE = {
  SERVERS_TITLE: 'Servidores Hardening',
  LAPTOPS_TITLE: 'Laptops Hardening',
  NAME: 'Nombre',
  TYPE: 'Tipo',
  SEARCH_PLACEHOLDER: 'Buscar asset...',
}

export const HARDENING_ASSETS_DETAILS = {
  POLICY_REMEDIATION: 'Remediación',
  OS: 'Sistema Operativo',
  LAST_UPDATED: 'Última Actualización',
  TYPE: 'Tipo',
  POLICIES_GROUPED_BY_CLUSTERS: 'Políticas por cluster',
  NO_POLICIES_ASSIGNED: 'No hay políticas aplicadas',
}
